import React from "react"
import { Zap, Clock } from "lucide-react"

export default function ShowcaseVideoCard({ video }) {
	return (
		<div className="flex flex-col bg-base-100 rounded-[1rem] overflow-hidden border border-base-300 shadow-xl hover:shadow-2xl hover:shadow-purple-500/10 transition-all duration-500 group">
			{/* Video Container - Side by Side */}
			<div className="grid grid-cols-2 gap-1 p-1 bg-base-200 aspect-[16/10]">
				<div className="relative h-full bg-black rounded-2xl overflow-hidden group/vid">
					<video
						src={`${video.video_url}#t=0.001`}
						className="w-full h-full object-cover"
						controls
						preload="metadata"
						playsInline
					/>
					<div className="absolute top-2 left-2 px-2 py-0.5 bg-black/60 backdrop-blur-md rounded-full text-[10px] font-bold text-white/80 border border-white/10 uppercase tracking-widest">
						Original
					</div>
				</div>
				<div className="relative h-full bg-black rounded-2xl overflow-hidden border border-primary/20 group/vid">
					<video
						src={`${video.downloadUrl}#t=0.001`}
						className="w-full h-full object-cover"
						controls
						preload="metadata"
						playsInline
					/>
					<div className="absolute top-2 left-2 px-2 py-0.5 bg-primary/80 backdrop-blur-md rounded-full text-[10px] font-bold text-white border border-white/20 uppercase tracking-widest shadow-lg">
						Generated
					</div>
				</div>
			</div>

			{/* Information Container */}
			<div className="p-6 flex flex-col flex-grow space-y-5">
				{/* Model Info */}
				<div className="flex items-center justify-between">
					<div className="flex items-center gap-2.5">
						<div className="w-8 h-8 rounded-xl bg-warning/10 flex items-center justify-center">
							<Zap size={16} className="text-warning" />
						</div>
						<div>
							<p className="text-[10px] font-black uppercase tracking-widest opacity-40 leading-none mb-1">AI Model</p>
							<p className="text-sm font-bold text-white truncate max-w-[120px]">
								{video.fal_model?.split('/').pop() || "Sync Model"}
							</p>
						</div>
					</div>
					<div className="text-[10px] opacity-30 flex items-center gap-1 font-medium">
						<Clock size={10} />
						{new Date(video._creationTime).toLocaleDateString()}
					</div>
				</div>

				{/* Attributes */}
				<div className="flex flex-wrap gap-2 pt-2">
					{video.person_age && (
						<div className="px-3 py-1 bg-base-200 rounded-full text-xs font-semibold text-base-content/70 border border-base-300">
							{video.person_age}
						</div>
					)}
					{video.person_sex && (
						<div className="px-3 py-1 bg-base-200 rounded-full text-xs font-semibold text-base-content/70 border border-base-300">
							{video.person_sex}
						</div>
					)}
					{video.person_style && (
						<div className="px-3 py-1 bg-base-200 rounded-full text-xs font-semibold text-base-content/70 border border-base-300">
							{video.person_style}
						</div>
					)}
					{video.person_purpose && (
						<div className="px-3 py-1 bg-base-200 rounded-full text-xs font-semibold text-base-content/70 border border-base-300">
							{video.person_purpose}
						</div>
					)}
				</div>
				
				{/* {video.name && (
					<div className="pt-4 mt-auto border-t border-base-200">
						<p className="text-xs text-base-content/50 italic line-clamp-2 leading-relaxed">
							"{video.name}"
						</p>
					</div>
				)} */}
			</div>
		</div>
	)
}

